import { render } from "./AllInvoicesView.vue?vue&type=template&id=689cb402"
import script from "./AllInvoicesView.vue?vue&type=script&lang=js"
export * from "./AllInvoicesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__